exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".events-nav-filter {\n  padding: 0 !important;\n}\n\n.events-filter .events-filter__event-statuses {\n  margin-bottom: 0 !important;\n}\n\n.events-filter .events-filter__event-types {\n  margin-bottom: 5rem;\n}\n\n.events-filter .events-filter__event-types>div:nth-child(2) {\n  background: rgba(100,230,51,0.5);\n}\n\n.events-filter .events-filter__event-types>div:nth-child(3) {\n  background: rgba(255,102,146,0.5);\n}\n\n.events-filter .events-filter__event-types>div:nth-child(4) {\n  background: rgba(131,154,167,0.5);\n}\n\n", ""]);

// exports
